/*
 * Default Callback Fn's For the CRE plugin interfacing with a Progress Modal View .
 * ( used whenever progress/abort is desired ).
 * Used For Document and Page Downloads, As Well As Inline PDF.
 * TODO:
 * - make this part of the main view (layout)?
 * - could set the context to the viewer model
 * - a CRE module? ... looking like this
*/


var fvChannel = require('glRadio').channel('FV'),
    DownloadView = require('../common/downloadFrame'),
    $ = require('jquery');


module.exports = function(options) {

    var vCh = options.vChannel;

    return {

        onStart: function() {

            vCh.trigger('modal:open',  {
                heading: (options.inlinePDF ? 'Loading ' : 'Downloading ') + (options.isPDF ? 'PDF' : 'Original'),
                cancelTitle: 'Cancel Download',
                onCancel: _.partial($.fn.creRequest.cancel, {byForce: true}) /* note .cancel will exist because a request must have been made -- see DVBC-807 -- should change arch or plugin */
            }, true);

            options.startCB && options.startCB();

        },

        onComplete: function(data) {

            vCh.trigger('modal:close');

            /*
             * Download in hidden frame view.
             * TODO: ( still? )
             * - change name to 'noAutoDownload
             * - could have frame in region
             */
            if ( !options.inlinePDF ) {

                var downloadView = new DownloadView({
                    src: data.downloadUrl,
                    container: $( vCh.request('getWrapper') )
                }).render();
            }

            options.completeCB && options.completeCB(data);
        },

        onError: function(errMsg) {

            vCh.trigger('modal:close');

            /*
             * May not want to show -- eg for pdf inline -- an auth check is made afterwards, then show then err message shown.
             * All of these could have the auth'd check
             */
            if ( !options.dontShowErrMsg ) {

                vCh.trigger('alert:show', {
                    type: 'error',
                    shortMessage: 'Download Error',
                    detailedMsg: errMsg,
                    closeTimeout: 3000
                });

            }

            options.errorCB && options.errorCB(errMsg);
        },

        onCheckState: function(renderStatus) {

            var rs = renderStatus;
            this.loadingView = this.loadingView || vCh.request('modalView'); //(new obj req'd each time)
            this.loadingView.triggerMethod('updateStatus', rs.completedPages, rs.totalPages, rs.stateDesc);

        },

        onCancel: function(renderStatus, cancelOpts) { //(when the cancel is complete -- user or force)

            var byForce = cancelOpts && cancelOpts.byForce; //(now from reset -- byForce implies uses hit cancel)
            vCh.trigger('modal:close') ;

            /* User Cancelled */
            if (!byForce) {
                vCh.trigger('alert:show', {
                    type: 'info',
                    shortMessage: 'Download Cancelled',
                    closeTimeout: 3000
                });
            }

            options.cancelCB && options.cancelCB(options);

        },
        /*
         * When request to cancel fails
         */
        onCancelError: function(errMsg) {

            vCh.trigger('modal:close');

            vCh.trigger('alert:show', {
                type: 'error',
                shortMessage: 'Cancel Error',
                detailedMsg: errMsg,
                closeTimeout: 3000
            });

            options.cancelErrCB && options.cancelErrCB();

        },

        CRE_ROOT: fvChannel.request('settings').getCRERoot(), // put in in api_url ?
        POLL_FREQ:  fvChannel.request('settings').crePollInterval

    };

};





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/creDownloadDefaults.js
 ** module id = 107
 ** module chunks = 0
 **/